import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { TrainingSession, emptyTrainingSession } from "../../../../interfaces/training-session";
import { getTrainingSessionSingle, updateTrainingSession } from "../../../../services/training-session";
import moment from 'moment';
import { LoadingSpinner } from "../../../general/loading-spinner";
import { ColorSelector } from "../../../general/color-selector";

interface CoachTrainingSessionEditProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionEdit(props: CoachTrainingSessionEditProps) {
    const [trainingSession, setTrainingSession] = useState<TrainingSession>(emptyTrainingSession);
    const [loading, setLoading] = useState(true);
    const [dateValue, setDateValue] = useState('');
    const [timeValue, setTimeValue] = useState('');
    const [color, setColor] = useState('#34B689');

    useEffect(() => {
        getTrainingSessionSingle(props.id)
            .then((response: any) => {
                setTrainingSession(response.data);
                setColor(response.data.color ? response.data.color : '#34B689');
                if (response.data.date_time != null && response.data.date_time.length > 0) {
                    setDateValue(moment(response.data.date_time).format("YYYY-MM-DD"));
                    setTimeValue(moment(response.data.date_time).format("HH:mm"));
                }
                setLoading(false);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        let date_time = '';
        if (event.target.date_part.value.length > 0) {
            date_time = event.target.date_part.value;
            if (event.target.time_part.value.length > 0) {
                date_time += ' ' + event.target.time_part.value + ':00'; 
            }
        }
        
        const body = {
            id: event.target.id.value,
            name: event.target.name.value,
            description: event.target.description.value,
            goals: event.target.goals.value,
            date_time: date_time,
            color: color
        }
        updateTrainingSession(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleSetColor = (color: string) => {
        setColor(color);
    }

    return (
        <Modal className="training-session-edit-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("edit_training_session") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { loading && 
                    <LoadingSpinner />
                }
                { !loading && 
                    <Form onSubmit={ handleSave }>
                        <div className="fields">
                            <Form.Control type="hidden" name="id" required defaultValue={ trainingSession.id } />
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                                <Form.Control type="text" name="name" required defaultValue={ trainingSession.name } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="description">
                                <Form.Label>{ t("description") }</Form.Label>
                                <Form.Control name="description" as="textarea" rows={5} defaultValue={ trainingSession.description } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="goals">
                                <Form.Label>{ t("goals") }</Form.Label>
                                <Form.Control name="goals" as="textarea" rows={5} defaultValue={ trainingSession.goals } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="color">
                                <Form.Label>{ t("color") }</Form.Label>
                                <ColorSelector setColor={ handleSetColor } defaultColor={ color } />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="date_time">
                                <Form.Label>{ t("date_time") }</Form.Label>
                                <div className="date-time-container">
                                    <Form.Control name="date_part" type="date" defaultValue={ dateValue } />
                                    <Form.Control name="time_part" type="time" defaultValue={ timeValue } />
                                </div>
                            </Form.Group>
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Save") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}